<template>
  <Animation :duration="{ enter: 350, leave: 200 }" enter="fadeIn" leave="fadeOut" appear>
    <div class="dialog-backdrop">
      <slot />
    </div>
  </Animation>
</template>

<style lang="postcss" scoped>
.dialog-backdrop {
  @apply fixed top-0 bottom-0 left-0 right-0 bg-[rgba(0,0,0,0.2)];
}
</style>

<script>
import Animation from '@/lego/components/tools/Animation.vue';

export default {
  name: 'DialogBackdropComponent',

  components: { Animation },
};
</script>
